import { CostingMethodLabel, Item, ItemTypeLabel } from "@forgepoint/shared";
import { formatAbsoluteTimestamp, formatCompactAge } from "@/lib/relativeTime";

interface ItemRowMetaProps {
  /** The item whose details are displayed. */
  item: Item;
}

/**
 * Renders an item's description over its type, costing method and freshness.
 * @param props - The item to describe
 * @returns The secondary lines for an item selector row
 */
export function ItemRowMeta({ item }: ItemRowMetaProps) {
  return (
    <>
      {item.description && <div className="truncate">{item.description}</div>}
      <div className="truncate">
        {ItemTypeLabel[item.type]} · {CostingMethodLabel[item.costingMethod]} ·
        updated{" "}
        <span title={formatAbsoluteTimestamp(item.updatedAt)}>
          {formatCompactAge(item.updatedAt)}
        </span>
      </div>
    </>
  );
}
